

class CreateScorecard {
    constructor() {
        this.courseId = null;
        this.loopId = null;
		this.teeId = null;
		this.qualifying = null;

        this.$course = $('.js-course');
        this.$courseInput = $('.js-course-input');
        this.$loop = $('.js-loop');
        this.$loopInput = $('.js-loop-input');
        this.$tee = $('.js-tee');
        this.$teeInput = $('.js-tee-input');
        this.$phcp = $('.js-phcp');
        this.$phcpVal = $('.js-phcp-value');
        this.$qualifying = $('.js-qualifying');
        this.$qualifyingInput = $('.js-qualifying-input');
        this.$qualifyingYes = $('.js-qualifying-yes');
        this.$qualifyingNotAllowedOption = $('.js-qualifying-not-allowed-option');
        this.$qualifyingNotAllowedMessagePlayer = $('.js-qualifying-not-allowed-msg-player');
		this.$qualifyingNotAllowedMessageLoop = $('.js-qualifying-not-allowed-msg-course');
		this.$competition = $('.js-competition');
		this.$competitionInput = $('.js-competition-input');
		this.$competitionYes = $('.js-competition-yes');
		this.$remark = $('.js-competition-remark');
        this.$marker = $('.js-marker');
        this.$markerInput = $('.js-marker-input');
        this.$form = $('.js-form');

        // check if needed element exists
        if (this.$form.length) {
            // init events
            this.events();
            // check default states
            this.setInitialState();
        }
    }

    setInitialState() {

        // If course is already set on page (re)load
        this.courseId = this.$courseInput.val();
        if (this.courseId !== '') {
            this.getCourse(this.courseId);
        }

        // If course and loop is already set on page (re)load
        this.loopId = this.$loopInput.val();
        if (this.courseId !== '' && this.loopId !== null) {
            this.getTee(this.loopId, this.courseId);
        }

        this.checkLoopIsQualifying();
    }

    /**
     * Initializes the event handlers
     */

    events() {

        // when the course changes
        this.$courseInput.on('change', (e) => {
            this.courseId = $(e.target).val();

            // only get course data when a course is selected
            // because we also have a 'Select course...' option without a value
            if (this.courseId !== '') {
                this.getCourse(this.courseId);
            } else {
                // hide loops and tees if no course is selected
                this.hide(this.$loop);
                this.hide(this.$tee);
                this.$phcpVal.text(this.$phcpVal.attr('data-empty-text'));
            }
        });

        // when the loop changes
        this.$loopInput.on('change', (e) => {
            this.loopId = $(e.target).val();

            // only get tee data when a loop is selected
            // because we also have a 'Select loop...' option without a value
            if (this.loopId !== '') {
                this.getTee(this.courseId, this.loopId);
				this.checkLoopIsQualifying();
				this.toggleElement(this.$marker, this.$qualifyingYes);
				this.toggleElement(this.$competition, this.$qualifyingYes);
                this.hide(this.$phcp);
           } else {
            }
        });

        // when the loop changes
        this.$teeInput.on('change', (e) => {
            this.teeId = $(e.target).val();

            // only get tee data when a loop is selected
            // because we also have a 'Select loop...' option without a value
            if (this.teeId !== '') {
                this.getPhcp(this.courseId, this.loopId, this.teeId);

                this.checkLoopIsQualifying();

            }
        });

        this.$qualifyingInput.on('change', () => {
			this.toggleElement(this.$marker, this.$qualifyingYes);
			this.toggleElement(this.$competition, this.$qualifyingYes);
		});

		this.$competitionInput.on('change', () => {
			this.toggleElement(this.$remark, this.$competitionYes);
		});
    }

    /**
     * Makes a jQuery element invisible
     * @param {Object} $el
     */

    hide($el) {
        $el.addClass('u-hide');
    }

    /**
     * Makes a jQuery element visible
     * @param {Object} $el
     */

    show($el) {
        $el.removeClass('u-hide');
    }

    /**
     * Populates loops select
     * @param {String} courseId
     */

    getCourse(courseId) {
        // hide loops an tees before we get the data
        this.hide(this.$loop);
        this.hide(this.$tee);
        this.hide(this.$phcp);
        this.$phcpVal.text(this.$phcpVal.attr('data-empty-text'));

        const defaultText = this.$loopInput.find('option:first').text();
        const loadingText = this.$loopInput.attr('data-loading-text');

        // disabled selection of the select element
        this.$loopInput.prop('disabled', true);
        // set the placeholder option text and disable it§
        this.$loopInput.find('option:first').prop({'selected': true, 'disabled': true}).text(loadingText);
        // remove all options except the default
        this.$loopInput.find('option:gt(0)').remove();
        // make the loop select box visible again
        this.show(this.$loop);

        const url = this.$loop.attr('data-url');
        const data = {
            courseId: courseId
        };

        $.get(url, data, (result) => {
            // loop through data object and append options
            _.map(result.Loops, (loop) => {
                this.$loopInput.append( $('<option>').attr('data-CanPlayQualifying', loop.CanPlayQualifying).text(loop.Name).val(loop.Id) );
            });
            // restore the option placeholder text
            this.$loopInput.find('option:first').text(defaultText);
            // enable the select again
            this.$loopInput.prop('disabled', false);
        });
    }

    /**
     * Populates tees select
     * @param {String} loopId
     * @param {String} gender
     */

    getTee(courseId, loopId) {
        const defaultText = this.$teeInput.find('option:first').text();
        const loadingText = this.$teeInput.attr('data-loading-text');

        // disabled selection of the select element
        this.$teeInput.prop('disabled', true);
        // set the placeholder option text and disable it§
        this.$teeInput.find('option:first').prop({'selected': true, 'disabled': true}).text(loadingText);
        // remove all options except the default
        this.$teeInput.find('option:gt(0)').remove();
        // make the loop select box visible again
        this.show(this.$tee);


        const url = this.$tee.attr('data-url');
        const data = {
            loopId: loopId,
            courseId: courseId
        };

        $.get(url, data, (result) => {
            // loop through data object and append options
            _.map(result, (tee) => {
                const text = tee.TeeName + (tee.IsQualifying ? "" : this.$teeInput.attr('data-nonqualifying'));

                this.$teeInput.append($('<option>').attr('data-CanPlayQualifying', tee.IsQualifying).text(text).val(tee.Tee));
            });

            // restore the option placeholder text
            this.$teeInput.find('option:first').text(defaultText);
            // enable the select again
            this.$teeInput.prop('disabled', false);
        });
    }

    getPhcp(courseId, loopId, teeId) {
        const loadingText = this.$phcpVal.attr('data-loading-text');
        this.$phcpVal.text(loadingText);

        this.show(this.$phcp);

        const url = this.$phcp.attr('data-url');
        const data = {
            loopId: loopId,
            courseId: courseId,
            tee: teeId
        };

        $.get(url, data, (result) => {
            if (!isNaN(result)) {
                this.$phcpVal.text(result);
            }
        });
    }

    /**
     * Check if a course is qualifying
     * @param {String} courseId
     */

    checkLoopIsQualifying() {
        // if a player is not allowed to play qualifying we don't have to check if a course is qaulifying
        if (this.$qualifyingNotAllowedMessagePlayer.is(':visible')) {
            return;
        }

        // Get the qualifying indicator from selected loop
        const CanPlayQualifying = this.$loopInput.find('option:selected').attr('data-CanPlayQualifying')
                                    && this.$teeInput.find('option:selected').attr('data-CanPlayQualifying');

        // course is not qualifying
        if (CanPlayQualifying === 'false') {
            // hide the marker input
			this.hide(this.$marker);
			// hide the competition input
			this.hide(this.$competition);
            // disabled the qualifying choice select
            this.$qualifyingInput.prop('disabled', true);
            // set the qualifying choice to 'no'
            this.$qualifyingNotAllowedOption.prop('selected', true);
            // show the 'course is not qualifying' message
            this.$qualifyingNotAllowedMessageLoop.removeClass('u-hide');
        // course is qualifying
        } else {
            // show the marker input
			this.show(this.$marker);
			// show the competition input
			this.show(this.$competition);
            // enable the qualifying choice select
            this.$qualifyingInput.prop('disabled', false);
            // remove the selected state from the 'not qualifying' choice
            // this.$qualifyingNotAllowedOption.prop('selected', false);
            // hide the 'course is not qualifying' message
            this.$qualifyingNotAllowedMessageLoop.addClass('u-hide');

            this.toggleElement(this.$marker, this.$qualifyingYes);
            this.toggleElement(this.$competition, this.$qualifyingYes);
        }
	}

	toggleElement(element, option) {
		if ($(option).is(':checked')) {
			this.show(element);
		} else {
			this.hide(element);
		}
	}
}

export default CreateScorecard;
